export default function cdnLoader({ src, width, quality }) {
  try {
    if (!src || src === 'null' || src === 'undefined') {
      src = '/hizli-cicek-resmi-.png';
    }

    if (src.startsWith('data:') || src.startsWith('blob:')) {
      return src;
    }

    const isAbsolute = /^https?:\/\//i.test(src);

    const isCdn = isAbsolute
      ? /\/\/cdn\.hizlicicek\.com/i.test(src) ||
        /\/\/cdn-dev\.hizlicicek\.com/i.test(src) ||
        /\/\/hzc-remove\.s3\.eu-west-1\.amazonaws\.com/i.test(src)
      : false;

    let absoluteSrc = src;
    if (!isAbsolute) {
      absoluteSrc = `https://cdn.hizlicicek.com/public${src}`;
    } else if (!isCdn) {
      return src;
    }

    const url = new URL(absoluteSrc);
    const pathname = url.pathname;
    const pathParts = pathname.split('/');
    const filename = pathParts[pathParts.length - 1];

    let fileType = 'webp';
    if (filename.toLowerCase().endsWith('.svg')) {
      fileType = 'svg';
    }

    if (typeof width !== 'number' || !Number.isFinite(width)) {
      const baseUrl = `${url.protocol}//${url.hostname}${url.pathname}`;
      return queryParams.toString() ? `${baseUrl}?${queryParams.toString()}` : baseUrl;
    }

    const w = Math.max(1, Math.round(width));
    const q = typeof quality === 'number' ? Math.max(85, Math.round(quality)) : 85;

    const segments = pathParts.slice(1, -1);

    const newPath = `/${segments.join('/')}/${w}x0/${q}/${fileType}/${filename}`;

    const baseUrl = url.hostname.includes('cdn-dev')
      ? 'https://cdn-dev.hizlicicek.com'
      : 'https://cdn.hizlicicek.com';

    return `${baseUrl}${newPath}`;
  } catch {
    return 'https://cdn.hizlicicek.com/public/empty.png';
  }
}
